import { useEffect, useState } from "react";
import { ref, onValue } from "firebase/database";
import type { IMeal } from "../types/types";
import { realtimeDb } from "../utils/firebase";
import { useProducts } from "./useProducts";
import { normalizePolish } from "../utils/normlizePolish";

export function useMeals() {
  const [meals, setMeals] = useState<IMeal[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { products } = useProducts();

  const mealsRef = ref(realtimeDb, "meals");

  useEffect(() => {
    const unsubscribe = onValue(
      mealsRef,
      snapshot => {
        const data: Record<string, IMeal> = snapshot.exists() ? snapshot.val() : {};
        const mappedMeals = Object.entries(data).map(([key, value]) => {
          const id = !Number.isNaN(key) ? normalizePolish(value.name) : key;
          return {
            ...value,
            id,
            ingredients: value.ingredients.map(({ id, quantity }) => {
              const findIng = products.find((p) => p.id === id);
              return { ...findIng!, quantity: quantity }
            })
          }
        });
        setMeals(Object.values(mappedMeals));
        setLoading(false);
      },
      err => {
        setError(err.message);
        setLoading(false);
      }
    );

    return () => unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products]);

  return { meals, loading, error };
}
